import React from "react";
import { connect } from "react-redux";
import {
  Pane,
  SearchInput,
  Button,
  Card,
  Avatar,
  Strong,
  Badge,
  Text,
  Spinner,
  toaster,
  InlineAlert,
  Small,
  Radio,
  TickCircleIcon,
} from "evergreen-ui";

import {
  searchBookings,
  getBookingTransactions,
  transactionCode,
  printBookingReceipt,
  printBookingStatement,
  enableReschedule,
  markNoShow,
  getBooking,
  bookingCheckIn,
} from "../external/actions";
import External from "../external/external";
import { getFormattedTime, getFormattedDate, getCookie } from "../util";
import BackBar from "../components/backBar";
import Loader from "../components/loader";
import BookingDetailsDialog from "../components/bookingDetailsDialog";
import ConfirmationDialog from "../components/confirmationDialog";
import BookingTransactionsDialog from "../components/bookingTransactionsDialog";
import PayNowDialog from "../components/paynowDialog";
import Reschedule from "../components/rescheduleDialog";
import RegularBookingCard from "../components/SearchBooking/RegularBookingCard";
import CustomBookingCard from "../components/SearchBooking/CustomBookingCard";
import BulkBookingCard from "../components/SearchBooking/BulkBookingCard";
import BulkBookingDetailsDialog from "../components/BulkBookingDetailsDialog";

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      pageNum: 1,
      defaultPageNum: 1,
      invalidSearchInput: false,
      bookingSearchData: "",
      nextPage: "",
      currentPage: "",
      totalPage: "",
      loader: false,
      loaderType1: false,
      bookingType: "regular",
      bookingDetails: "",
      showBookingDetailsDialog: false,
      showBulkBookingDetailsDialog: false,
      bookingDetailsIndex: null,
      daysData: {
        0: "Mon",
        1: "Tue",
        2: "Wed",
        3: "Thu",
        4: "Fri",
        5: "Sat",
        6: "Sun",
      },
      confirmationDialog: {
        isShown: false,
        header: "",
        confirmLabel: "",
        cancelLabel: "",
        intent: "none",
        information: "",
        action: null,
        cancelAction: null,
      },
      bookingStatusIntentMap: {
        upcoming: "green",
        completed: "orange",
        ongoing: "blue",
        cancelled: "red",
      },
      bookingTransactionsDialogIsShown: false,
      payNowDialogIsShown: false,
      rescheduleDialogIsShown: false,
      isInvalidSearchString: false,
      noSearchResultFound: false,
    };
    this.baseState = this.state;
  }

  resetPageNum = async () => {
    await this.setState({ pageNum: 1 });
  };

  onLoad = async () => {
    document.getElementById("search-input").focus();
    window.addEventListener("scroll", this.onScroll, false);
  };

  componentDidMount = async () => {
    const query = new URLSearchParams(this.props.location.search);
    const bookingId = query.get("bookingId");
    const checkIn = false;
    const bookingClick = false;
    console.log({ checkIn });

    if (bookingId) {
      await this.setState({
        searchString: bookingId,
      });
      await this.handleShowResults();
      console.log(bookingClick);
      if (bookingClick === "true") {
        let div = document.getElementById("booking-details");

        if (div) {
          div.click();
        }
      }
      if (checkIn) {
        if (
          this.props?.bookingSearchData["paginationData"] &&
          this.props?.bookingSearchData?.bookingDetails[0]?.checkinData === null
        ) {
          this.handleBookingCheckIn(bookingId);
        }
      }
    }

    await this.onLoad();
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
  }

  onScroll = async () => {
    const { loader, searchString, bookingType } = this.state;
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    const clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
    const scrolledToBottom =
      Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    let endList =
      this.props.bookingSearchData &&
      this.props.bookingSearchData["paginationData"] &&
      this.props.bookingSearchData["paginationData"]["next"];
    if (
      scrolledToBottom &&
      endList &&
      endList !== -1 &&
      !loader &&
      searchString
    ) {
      let reqParams = {
        input: searchString,
        page: endList,
      };
      await this.setState({ loader: true });
      await this.props.dispatch(
        searchBookings(reqParams, bookingType, this.state.bookingSearchData)
      );
      await this.setState({
        bookingSearchData: this.props.bookingSearchData.bookingDetails,
        loader: false,
      });
    }
  };

  handleSearchInputChange = async (e) => {
    e.persist();
    if (e.target.value.toString() === "") {
      await this.setState({
        bookingSearchData: null,
        searchString: "",
      });
    }
    await this.setState({
      noSearchResultFound: false,
      isInvalidSearchString: false,
      searchString: e.target.value.toString(),
      invalidSearchInput: false,
      pageNum: 1,
    });
    await this.resetPageNum();
  };

  handleShowResults = async () => {
    const { searchString, pageNum, bookingSearchData, bookingType } =
      this.state;

    const reqParams = {
      input: searchString,
      page: pageNum,
    };
    if (!bookingSearchData && searchString) {
      await this.setState({
        loader: true,
      });
    }
    if (searchString.length > 0) {
      await this.props.dispatch(searchBookings(reqParams, bookingType));
      if (this.props.bookingSearchData["requestStatus"] === 1) {
        await this.setState({
          bookingSearchData: this.props.bookingSearchData.bookingDetails,
          nextPage: this.props.bookingSearchData["paginationData"]["next"],
          currentPage:
            this.props.bookingSearchData["paginationData"]["previous"],
          totalPage: this.props.bookingSearchData["paginationData"]["total"],
          loader: false,
        });
      } else if (this.props.bookingSearchData["requestStatus"] === -1) {
        this.setState({
          loaderType1: false,
          loader: false,
        });
      } else {
        this.setState({
          ...this.baseState,
          noSearchResultFound: true,
        });
        await this.props.dispatch(searchBookings(reqParams));
        if (this.props.bookingSearchData["paginationData"]) {
          await this.setState({
            bookingSearchData: this.props?.bookingSearchData?.bookingDetails,
            nextPage: this.props?.bookingSearchData["paginationData"]["next"],
            currentPage:
              this.props?.bookingSearchData["paginationData"]["previous"],
            totalPage: this.props?.bookingSearchData["paginationData"]["total"],
            loader: false,
          });
        }
      }
    } else {
      if (searchString.length === 0) {
        await this.setState({
          isInvalidSearchString: true,
        });
      } else {
        toaster.danger(this.props.bookingSearchData.message);
      }
    }
  };

  showBookingDialog = async (status) => {
    this.setState({
      showBulkBookingDetailsDialog: false,
      showBookingDetailsDialog: status,
    });
  };

  showBulkBookingDialog = async (status) => {
    this.setState({
      showBookingDetailsDialog: false,
      showBulkBookingDetailsDialog: status,
    });
  };

  showBookingDetailsDialog = async (details, index) => {
    await this.setState({
      bookingDetails: details,
      bookingDetailsIndex: index,
    });
    await this.showBookingDialog(true);
  };

  showBulkBookingDetailsDialog = async (details, index) => {
    await this.setState({
      bookingDetails: details,
      bookingDetailsIndex: index,
    });
    await this.showBulkBookingDialog(true);
  };

  back = async () => {
    this.setState({
      ...this.baseState,
    });
    this.props.dispatch({ type: "SET_BOOKING_SEARCH_DATA", data: "" });
    this.props.history.push("/");
  };

  sendBookingPaymentLink = async (bookingId) => {
    const paymentLink = await External.sendBookingPaymentLink({ bookingId });
    if (paymentLink.data["requestStatus"]) {
      toaster.success("Payment Link Sent", { id: "send-payment-link" });
    } else {
      toaster.warning(paymentLink.data["message"], { id: "send-payment-link" });
    }
  };

  bookingCancellation = async (bookingId) => {
    await this.showConfirmationDialog({
      isShown: false,
    });
    await this.setState({
      loaderType1: true,
    });
    const cancellation = await External.cancelBooking({
      bookingId:
        this.state.bookingType === "regular" ? bookingId.toString() : null,
      patternBookingId:
        this.state.bookingType === "bulk" ? bookingId.toString() : null,
      cancelRemarks: "",
      playoCancelRemarks: "",
      refundMode: "Cash",
      refundType: 1,
      transactionData: {
        type: -1,
        mode: 1,
        handler: getCookie("username"),
        place: "Partner-App",
      },
    });
    const { bookingDetailsIndex } = this.state;
    const { bookingSearchData } = this.props;

    if (cancellation.data.requestStatus === 1) {
      Object.assign(bookingSearchData["bookingDetails"][bookingDetailsIndex], {
        bookingCancelled: true,
        bookingStatus: "Cancelled",
      });
      await this.props.dispatch({
        type: "SET_BOOKING_SEARCH_DATA",
        data: bookingSearchData,
      });
      await this.setState({ loaderType1: false });
      if (cancellation.data["requestStatus"]) {
        toaster.success("Booking Cancelled", { id: "cancel" });
      } else {
        toaster.danger(cancellation.data["message"], { id: "cancel" });
      }
    } else if (cancellation.data.requestStatus === -1) {
      toaster.warning("you dont have permission");
      this.setState({
        loader: false,
        loaderType1: false,
      });
    } else {
      toaster.warning(cancellation.data["message"]);
      this.setState({
        loader: false,
        loaderType1: false,
      });
    }
  };

  showConfirmationDialog = async (data) => {
    await this.setState({
      confirmationDialog: {
        isShown: data["status"] || false,
        header: data["header"] || false,
        intent: data["intent"] || "none",
        confirmLabel: data["confirmLabel"] || "",
        cancelLabel: data["cancelLabel"] || "cancel",
        information: data["information"] || "",
        action: data["action"] || null,
      },
    });
  };

  printReceipt = async (transactionId) => {
    let reqParam = {
      transactionId,
    };
    this.props.dispatch(printBookingReceipt(reqParam));
  };

  printStatement = async (bookingId, bulk = false) => {
    let reqParam = {
      [bulk ? "patternBookingId" : "bookingId"]: bookingId,
    };

    this.props.dispatch(printBookingStatement(reqParam));
  };

  showBookingTransactionsDialog = async (status, bookingId) => {
    if (status) {
      await this.props.dispatch(getBookingTransactions({ bookingId }));
    }
    await this.setState({
      bookingTransactionsDialogIsShown: status,
    });
  };

  showPayNowDialog = async (status, bookingId) => {
    await this.props.dispatch(transactionCode());
    const { bookingDetailsIndex } = this.state;
    const { bookingSearchData, bookingDetails } = this.props;
    if (bookingId) {
      if (this.props.bookingDetails["requestStatus"] === 1) {
        this.setState({
          bookingDetails: this.props.bookingDetails.bookingDetails[0],
          payNowDialogIsShown: status,
        });
        bookingSearchData["bookingDetails"][bookingDetailsIndex] =
          bookingDetails.bookingDetails[0];
      }
    } else {
      this.setState({
        payNowDialogIsShown: status,
      });
    }
  };

  handleBookingCheckIn = async (bookingId, id) => {
    let data = {
      bookingId: bookingId,
      id,
    };
    const { bookingDetailsIndex } = this.state;
    const { bookingSearchData, bookingDetails } = this.props;
    this.props.dispatch(bookingCheckIn(data)).then((res) => {
      if (res.requestStatus === 1) {
        this.props
          .dispatch(
            getBooking({
              bookingId: bookingId,
            })
          )
          .then(() => {
            this.setState({
              bookingDetails: this.props.bookingDetails.bookingDetails.find(
                (booking) =>
                  booking.dateBooked === this.state.bookingDetails.dateBooked
              ),
            });
            if (this.props.bookingDetails.bookingDetails?.length > 1) {
              if (id !== undefined && id !== null) {
                bookingSearchData["bookingDetails"][bookingDetailsIndex] =
                  this.props.bookingDetails.bookingDetails.find(
                    (booking) =>
                      booking.dateBooked ===
                      this.state.bookingDetails.dateBooked
                  );
              }
            } else {
              bookingSearchData["bookingDetails"][bookingDetailsIndex] =
                this.props.bookingDetails.bookingDetails[0];
            }
          });
      }
    });
  };

  onNoShow = async (bookingId) => {
    let reqParams = { bookingId: bookingId };
    await this.props.dispatch(markNoShow(reqParams));

    if (this.props.markNoShow) {
      if (this.props.markNoShow.requestStatus === -1) {
        toaster.notify("Sorry, you don't have permission to do that");
      } else if (this.props.markNoShow.requestStatus === 1) {
        toaster.success(this.props.markNoShow.message);
      } else if (this.props.markNoShow.requestStatus === 0) {
        toaster.danger(this.props.markNoShow.message);
      }

      await this.props.dispatch(
        getBooking({
          bookingId: bookingId,
        })
      );

      this.setState({
        bookingDetails: this.props.bookingDetails.bookingDetails[0],
      });
    }
  };
  enableReschedule = async (bookingId, startTime) => {
    let reqParams = { bookingId: bookingId };
    await this.props.dispatch(enableReschedule(reqParams));

    if (this.props.enableReschedule) {
      if (this.props.enableReschedule.requestStatus === -1) {
        toaster.notify("Sorry, you don't have permission to do that");
      } else if (this.props.enableReschedule.requestStatus === 1) {
        toaster.success(this.props.enableReschedule.message);
      } else if (this.props.enableReschedule.requestStatus === 0) {
        toaster.danger(this.props.enableReschedule.message);
      }
    }
    await this.props.dispatch(
      getBooking({
        bookingId: bookingId,
      })
    );

    this.setState({
      bookingDetails: this.props.bookingDetails.bookingDetails[0],
    });
  };

  showRescheduleDialog = async (status, bookingId) => {
    const { bookingDetailsIndex } = this.state;
    const { bookingSearchData, bookingDetails } = this.props;
    if (bookingId) {
      if (this.props.bookingDetails["requestStatus"] === 1) {
        this.setState({
          bookingDetails: this.props.bookingDetails.bookingDetails[0],
          rescheduleDialogIsShown: status,
        });
        bookingSearchData["bookingDetails"][bookingDetailsIndex] =
          bookingDetails.bookingDetails[0];
      }
    } else {
      this.setState({
        rescheduleDialogIsShown: status,
      });
    }
  };

  handleBookingTypeChange = (event) => {
    this.setState({
      ...this.baseState,
      bookingType: event.target.value,
    });
  };

  render() {
    const {
      bookingSearchData,
      bookingStatusIntentMap,
      loader,
      loaderType1,
      showBookingDetailsDialog,
      bookingDetails,
      confirmationDialog,
      bookingTransactionsDialogIsShown,
      payNowDialogIsShown,
      rescheduleDialogIsShown,
      isInvalidSearchString,
      noSearchResultFound,
      searchString,
      bookingType,
      showBulkBookingDetailsDialog,
    } = this.state;

    return (
      <React.Fragment>
        <BackBar back={this.back} title={"Search"} />
        <Pane
          display="flex"
          marginTop={10}
          alignContent={"center"}
          flexDirection="row"
          marginX={10}
          gap={24}
          position={"sticky"}
          background={"white"}
          top={44}
          zIndex={10}
        >
          <Radio
            label="Regular Booking"
            value="regular"
            checked={bookingType === "regular"}
            onChange={this.handleBookingTypeChange}
          />

          <Radio
            label="Bulk Booking"
            value="bulk"
            checked={bookingType === "bulk"}
            onChange={this.handleBookingTypeChange}
          />
        </Pane>
        <Pane
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
          background="white"
        >
          <Pane
            position={"sticky"}
            top={60}
            zIndex={1}
            display={"flex"}
            paddingTop={20}
            paddingBottom={20}
            paddingLeft={10}
            paddingRight={10}
            marginBottom={10}
            borderBottom={"default"}
            background={"tint1"}
            width={"100vw"}
            justifyContent={"space-between"}
          >
            <Pane width={"95%"}>
              <SearchInput
                id={"search-input"}
                width={"95%"}
                value={searchString}
                placeholder={
                  bookingType === "bulk"
                    ? "Bulk Booking ID or Phone Number"
                    : "Booking ID or Phone Number"
                }
                onChange={(e) => this.handleSearchInputChange(e)}
                isInvalid={isInvalidSearchString}
              />
              {isInvalidSearchString && (
                <InlineAlert
                  marginTop={5}
                  marginBottom={-10}
                  width={"95%"}
                  intent={"danger"}
                >
                  <Small color={"#bf0e08"} fontWeight={400}>
                    Please enter a valid search value
                  </Small>
                </InlineAlert>
              )}
            </Pane>
            <Button appearance={"primary"} onClick={this.handleShowResults}>
              Search
            </Button>
          </Pane>
          {bookingSearchData ? (
            bookingSearchData.map((booking, index) => {
              const { customerDetails } = booking;

              if (booking.type === 1) {
                return (
                  <RegularBookingCard
                    customerDetails={customerDetails}
                    booking={booking}
                    index={index}
                    bookingStatusIntentMap={bookingStatusIntentMap}
                    showBookingDetailsDialog={this.showBookingDetailsDialog}
                  />
                );
              } else if (booking.type === 2 || booking.type == 0) {
                return (
                  <CustomBookingCard
                    customerDetails={customerDetails}
                    booking={booking}
                    index={index}
                    bookingStatusIntentMap={bookingStatusIntentMap}
                    showBookingDetailsDialog={this.showBookingDetailsDialog}
                  />
                );
              } else if (bookingType === "bulk") {
                return (
                  <BulkBookingCard
                    customerDetails={customerDetails}
                    booking={booking}
                    index={index}
                    bookingStatusIntentMap={bookingStatusIntentMap}
                    showBulkBookingDetailsDialog={
                      this.showBulkBookingDetailsDialog
                    }
                  />
                );
              }
              // return booking?.type === 1 ? (
              //   <RegularBookingCard
              //     customerDetails={customerDetails}
              //     booking={booking}
              //     index={index}
              //     bookingStatusIntentMap={bookingStatusIntentMap}
              //     showBookingDetailsDialog={this.showBookingDetailsDialog}
              //   />
              // ) : (
              //   <Pane>Custom</Pane>
              // );
            })
          ) : (
            <React.Fragment>
              {noSearchResultFound ? (
                <InlineAlert intent={"warning"}>
                  No Matching Results
                </InlineAlert>
              ) : (
                <React.Fragment />
              )}
            </React.Fragment>
          )}
          <BookingDetailsDialog
            isShown={showBookingDetailsDialog}
            showDialog={this.showBookingDialog}
            bookingDetails={bookingDetails}
            sendBookingPaymentLink={this.sendBookingPaymentLink}
            cancelBooking={this.bookingCancellation}
            showConfirmationDialog={this.showConfirmationDialog}
            showBookingTransactionsDialog={this.showBookingTransactionsDialog}
            showPayNowDialog={this.showPayNowDialog}
            showRescheduleDialog={this.showRescheduleDialog}
            printStatement={this.printStatement}
            enableReschedule={this.enableReschedule}
            onNoShow={this.onNoShow}
            bookingCheckIn={this.handleBookingCheckIn}
          />
          {bookingType === "bulk" && (
            <BulkBookingDetailsDialog
              isShown={showBulkBookingDetailsDialog}
              showDialog={this.showBulkBookingDialog}
              bookingDetails={bookingDetails}
              cancelBooking={this.bookingCancellation}
              showBookingTransactionsDialog={this.showBookingTransactionsDialog}
              printStatement={this.printStatement}
              daysData={this.state.daysData}
              showConfirmationDialog={this.showConfirmationDialog}
            />
          )}
          {loader ? <Spinner margin={5} /> : null}
          {loaderType1 && <Loader type={1} />}
          <ConfirmationDialog
            showDialog={this.showConfirmationDialog}
            isShown={confirmationDialog.isShown}
            header={confirmationDialog.header}
            confirmLabel={confirmationDialog.confirmLabel}
            cancelLabel={confirmationDialog.cancelLabel}
            intent={confirmationDialog.intent}
            information={confirmationDialog.information}
            action={confirmationDialog.action}
            cancelAction={confirmationDialog.cancelAction}
          />
          <BookingTransactionsDialog
            isShown={bookingTransactionsDialogIsShown}
            showBookingTransactionsDialog={this.showBookingTransactionsDialog}
            printReceipt={this.printReceipt}
          />
          <PayNowDialog
            isShown={payNowDialogIsShown}
            showPayNowDialog={this.showPayNowDialog}
            bookingDetails={bookingDetails}
          />
          <Reschedule
            isShown={rescheduleDialogIsShown}
            showRescheduleDialog={this.showRescheduleDialog}
            bookingDetails={bookingDetails}
            showDialog={this.showBookingDialog}
          />
        </Pane>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({
  bookingSearchData,
  bookingTransactionsData,
  bookingDetails,
  enableReschedule,
  markNoShow,
}) => ({
  bookingSearchData,
  bookingTransactionsData,
  bookingDetails,
  enableReschedule,
  markNoShow,
});

export default connect(mapStateToProps)(Search);
